import { render, staticRenderFns } from "./NotSupported.vue?vue&type=template&id=28cf5a6f&scoped=true"
import script from "./NotSupported.vue?vue&type=script&lang=js"
export * from "./NotSupported.vue?vue&type=script&lang=js"
import style0 from "./NotSupported.vue?vue&type=style&index=0&id=28cf5a6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cf5a6f",
  null
  
)

export default component.exports